export default "__VITE_ASSET__b56e629f__"